<template>
  <div class="package-analysis-root">
    <el-container>
      <el-aside class="aside" style="">
        <div class="app-select-wrapper">
          <el-select
            v-model="currentApp"
            ref="appSelect"
            size="large"
            filterable
            @change="handleSelectAppChange"
          >
            <AppSelectOptions :apps="appsSelect" :labelIcon="false" />
          </el-select>
        </div>
        <div class="app-version-wrapper">
          <el-tabs class="versiontab" v-model="activeName">
            <el-tab-pane label="原始" style="font-size: 14px" name="first">
              <div>
                <el-tree
                  :data="appVersion"
                  :props="{
                    children: 'children',
                    label: 'label',
                  }"
                  @node-click="handleSelectNode"
                ></el-tree>
              </div>
            </el-tab-pane>
            <el-tab-pane label="临时" style="font-size: 14px" name="second">
              <el-upload
                :disabled="uploadstatus == 'warning'"
                v-show="currentApp.length > 0"
                action="https://tentacles-zh.seasungame.com:33338/temporary"
                :show-file-list="false"
                accept=".txt"
                :data="uploaddata"
                name="uploadfile"
                :on-success="handleUploadSuccess"
                :on-error="handleUploadError"
                :on-progress="handleUploadProgress"
                :before-upload="handleBeforeUpload"
              >
                <el-button link type="primary" class="uploadbtn"
                  ><i class="iconfont icon-upload_filled"></i>上传
                </el-button>
              </el-upload>
              <div
                style="position: absolute; width: 167px; left: 55px; top: 2px"
              >
                <el-progress
                  :percentage="uploadprogress"
                  :status="uploadstatus"
                ></el-progress>
              </div>
              <div>
                <div v-for="item in tempDateList" :key="item.label">
                  <el-button
                    @click="handleSelectTemp(item)"
                    link
                    type="primary"
                    >{{ item.label }}</el-button
                  >
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-aside>
      <el-main class="main">
        <TagsView
          @selectTagEvent="handleChangeViewByTag"
          @closeSelectedTag="handleCloseSelectedTag"
          @closeRightTags="handleCloseRightTags"
          @closeAllTags="handleCloseAllTags"
          :tagdatas="tagdatas"
        />
        <div class="trendcss">
          <el-button link type="primary" @click="handleOpenTrendWindow"
            >包体变化趋势分析</el-button
          >
        </div>
        <div class="analysiscss">
          <div
            v-for="item in tagdatas"
            v-show="item.show === true"
            :key="item.title"
          >
            <component
              :key="item.title"
              :is="components[item.type]"
              :activeTab="item.deftab"
              :param="item.param"
              @showGraph="handleShowGraph"
              @selectCard="handleSelectCard"
              @selectRow="handleSelectRow"
            />
          </div>
          <el-dialog
            :close-on-click-modal="false"
            width="1400px"
            top="50px"
            @opened="handleGraphVisibled"
            @close="handleGraphClosed"
            v-model="graphVisible"
          >
            <GraphChart
              @graphChartClick="handleGraphChartClick"
              ref="graphChartRef"
            ></GraphChart>
          </el-dialog>
        </div>
      </el-main>
    </el-container>

    <el-drawer
      custom-class="analysis-drawer"
      @opened="openDrawEnd"
      title=""
      size="80%"
      v-model="trendflag"
      :with-header="true"
      :show-close="true"
    >
      <TrendView ref="trendViewRef" :appid="currentApp"></TrendView>
    </el-drawer>
  </div>
</template>

<script setup>
import { useProjectStore } from "@/Store/ProjectStore";
import { storeToRefs } from "pinia";
import AppSelectOptions from "@/Components/AppDetail/Detail/Info/AppSelectOptions.vue";
import TagsView from "./PackageAnalysis/TagsView.vue";
import overview from "./PackageAnalysis/Overview.vue";
import boundlelist from "./PackageAnalysis/BoundleList.vue";
import boundledetail from "./PackageAnalysis/BoundleDetail.vue";
import scenelist from "./PackageAnalysis/SceneList.vue";
import scenedetail from "./PackageAnalysis/SceneDetail.vue";
import assetslist from "./PackageAnalysis/AssetsList.vue";
import assetsdetail from "./PackageAnalysis/AssetsDetail.vue";
import GraphChart from "./PackageAnalysis/GraphChart.vue";
import TrendView from "./PackageAnalysis/TrendView.vue";
import { computed, getCurrentInstance, ref } from "vue";
import {
  apiPackageParseTemporary,
  apiPackageParseVersionList,
} from "@/Api/AppApi";

const { appContext } = getCurrentInstance();
const $message = appContext.config.globalProperties.$message;

const projectStore = useProjectStore();
const { projectApps } = storeToRefs(projectStore);

const appsSelect = computed(() => projectApps.value.filter((v) => !v.disabled));
const currentApp = ref("");

const components = {
  overview,
  boundlelist,
  boundledetail,
  scenelist,
  scenedetail,
  assetslist,
  assetsdetail,
};

const appVersion = ref([]);
function handleSelectAppChange(appid) {
  apiPackageParseVersionList(appid).then((res) => {
    if (res.code === 0) {
      appVersion.value = res.data;
    }
  });
  loadTempDateList(appid);
}

const tempDateList = ref([]);
async function loadTempDateList(appid) {
  const res = await apiPackageParseTemporary(appid);
  if (res.code === 0) {
    tempDateList.value = res.data;
  }
}

const activeName = ref("first");

const tagdatas = ref([]);
let currentVersionId = "";
function handleSelectNode(data) {
  if (data.type === "package") {
    tagdatas.value = [];
    currentVersionId = data.versionid;
    tagdatas.value.push({
      type: "overview",
      title: "分析总览(" + data.label + ")",
      affix: true,
      show: true,
      param: { versionid: data.versionid },
    });
  }
}

const uploadprogress = ref(0);
const uploadstatus = ref("");
const uploaddata = ref({});
function handleUploadSuccess() {
  uploadprogress.value = 100;
  uploadstatus.value = "success";
  loadTempDateList(currentApp.value);
}
function handleUploadError() {
  uploadprogress.value = 100;
  uploadstatus.value = "error";
}
function handleUploadProgress(event) {
  uploadprogress.value = Math.round(
    event.percent > 20 ? event.percent - 20 : event.percent
  );
}
function handleBeforeUpload(file) {
  const isTxt = file.type === "text/plain";
  if (!isTxt) {
    $message.error("只能上传txt文件");
    return false;
  } else {
    uploaddata.value.appid = currentApp.value;
    uploadstatus.value = "warning";
    uploadprogress.value = 0;
    return true;
  }
}

function handleSelectTemp(data) {
  data.type = "package";
  handleSelectNode(data);
}

function fidHadinTagView(key) {
  let rt = false;
  for (const item of tagdatas.value) {
    item.show = false;
    if (item.title === key) {
      rt = item;
    }
  }
  return rt;
}
function handleChangeViewByTag(tag) {
  const _tag = fidHadinTagView(tag.title);
  if (_tag) {
    _tag.show = true;
  }
}
function handleCloseSelectedTag(tag) {
  let _flag = false;
  for (let i = 0; i < tagdatas.value.length; i++) {
    if (tagdatas.value[i].title === tag.title) {
      if (tagdatas.value[i].show === true) {
        _flag = true;
      }
      tagdatas.value.splice(i, 1);
      break;
    }
  }
  if (_flag) {
    tagdatas.value[tagdatas.value.length - 1].show = true;
  }
}
function handleCloseRightTags(tag) {
  let index = -1;
  let show = -1;
  for (let i = 0; i < tagdatas.value.length; i++) {
    if (tagdatas.value[i].title === tag.title) {
      index = i;
    }
    if (tagdatas.value[i].show === true) {
      show = i;
    }
  }
  tagdatas.value.splice(index + 1, tagdatas.value.length - index - 1);
  if (show >= index) {
    tagdatas.value[tagdatas.value.length - 1].show = true;
  }
}
function handleCloseAllTags() {
  tagdatas.value.splice(1, tagdatas.value.length - 1);
  tagdatas.value[0].show = true;
}

const trendflag = ref(false);
function handleOpenTrendWindow() {
  trendflag.value = true;
}

const graphVisible = ref(false);
let graphParam = null;
function handleShowGraph(param) {
  graphVisible.value = true;
  graphParam = param;
}
function handleSelectCard(name) {
  const tag = fidHadinTagView(name);
  if (tag) {
    tag.show = true;
  } else {
    const param = {
      versionid: currentVersionId,
      type: undefined,
    };
    let type = name;
    if (name === "boundlelist") {
      type = "boundlelist";
      param.type = "normal";
    } else if (name === "boundlelist_circlebundle") {
      type = "boundlelist";
      param.type = "circlebundle";
    } else if (name === "boundlelist_toobig") {
      type = "boundlelist";
      param.type = "toobigbundle";
    }
    tagdatas.value.push({
      type: type,
      title: name,
      affix: false,
      show: true,
      param: param,
    });
  }
}
function handleSelectRow(data) {
  const tag = fidHadinTagView(data.name);
  if (tag) {
    tag.show = true;
  } else {
    tagdatas.value.push({
      type: data.viewType,
      title: data.name,
      affix: false,
      show: true,
      param: { versionid: currentVersionId, name: data.name },
      deftab: data.deftab,
    });
  }
}

const graphChartRef = ref(null);
function handleGraphVisibled() {
  graphChartRef.value.init(graphParam);
}
function handleGraphClosed() {
  graphChartRef.value.clear();
}
function handleGraphChartClick(data) {
  graphVisible.value = false;
  const tag = fidHadinTagView(data.name);
  if (tag) {
    tag.show = true;
  } else {
    tagdatas.value.push({
      type: data.viewType,
      title: data.name,
      affix: false,
      show: true,
      param: { versionid: currentVersionId, name: data.name },
      deftab: data.deftab,
    });
  }
}

const trendViewRef = ref(null);
function openDrawEnd() {
  trendViewRef.value.loadChartData();
}
</script>

<style lang="scss" scoped>
.package-analysis-root {
  padding: 20px;
}

.aside {
  width: 218px;
  height: calc(100vh - 90px);
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin-bottom: 0;
  background-color: unset;
  padding: 0;
}

.app-select-wrapper {
  width: 100%;
  margin-bottom: 12px;

  & :deep() .el-select {
    width: 100%;
  }
}

.app-version-wrapper {
  border: 1px solid #e1e1e1;
  height: calc(100% - 50px);
  background: #fff;
  padding-left: 5px;
  padding-right: 5px;
  overflow: hidden;
}

.analysiscss {
  margin-top: 30px;
}

.uploadbtn {
  font-size: 12px;
  position: relative;
  top: -9px;
  left: 2px;
  z-index: 1;
}

.versiontab {
  height: 100%;

  & :deep() {
    .el-tabs__content {
      height: calc(100% - 55px);
      overflow: auto;
    }

    .el-tabs__nav-wrap {
      padding-left: 12px;
    }

    .el-tabs__item {
      font-size: 14px;
      padding: 0 12px;
    }
  }
}

.main {
  padding: 0 0 0 12px;
  position: relative;
  overflow: hidden;
}

.trendcss {
  position: absolute;
  right: 12px;
}

.package-analysis-root :deep() .analysis-drawer {
  .el-drawer__header {
    margin-bottom: 0;
  }
}
</style>
